
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDeleteFilledGoogle as ObiDeleteFilledGoogleElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-delete-filled-google.js';
 
 
 

 
 export const ObiDeleteFilledGoogle = createComponent({
   react: React,
   tagName: 'obi-delete-filled-google',
   elementClass: ObiDeleteFilledGoogleElement,
   events: {
     
   }
  });
 
 